<template>
  <div class="page-container">
    <div class="page-module">
      <div class="page-title">创建战队</div>
      <div class="msg">您的服务中心还未创建战队，请先创建</div>
      <div class="main-content">
        <div class="title">
          战队名<span class="tips margin-left-16">（8个字以内）</span></div>
        <input  class="team-name" v-model="teamName" maxlength="8" placeholder="请输入您的战队名" placeholder-class="placeholder"/>
        <div class="title">服务中心名<span class="margin-left-16">（15个字以内）</span></div>
        <input class="team-name"  v-model="servicePointName" placeholder="请输入您的服务中心名字" />
      </div>
    </div>
    <div class="bottom-content">
      <!-- <div class="tips-1">报名后添加战队成员</div> -->
      <div class="sign-button" @click="signUp">提交</div>
    </div>
  </div>
</template>

<script>
import {Toast, Dialog} from "vant";
import {matchTeamSignUpV2} from "../../api/winterGame";
import {debounce} from "@/util/util";
export default {
    data(){
        return {
            teamName:'',
            servicePointName:'',
        }
    },
  methods: {
    signUp() {
        let teamName = this.teamName.trim().replaceAll(" ","")
        let servicePointName = this.servicePointName.trim().replaceAll(" ","")
        if(teamName == '')
        {
            Toast('战队名不能为空');
            return
        }

        if(teamName.length > 8){
            Toast('战队名不可超过8个字符')
            return
        }
        const reg = new RegExp(/^[A-Za-z0-9\u4e00-\u9fa5]+$/);
        //判断输入框中有内容
        if(!reg.test(teamName))
        {
            Toast("请输入中文、数字或英文");
            return
        }

        if(servicePointName.length > 15){
            Toast('服务中心名超过限制，请重新输入')
            return
        }

      this.matchTeamSignUpV2(teamName,servicePointName)
    },
      async matchTeamSignUpV2(teamName,servicePointName) {
          this.userInfoId = JSON.parse(localStorage.getItem('userInfoId')) || {}
          let { campusId, openId,agentUserId } = this.userInfoId || {}

          let params = {
              param: {
                  campusId,
                  currentUerId:agentUserId,
                  "teamId": 0,
                  teamName:teamName,//松鼠杯类型
                  servicePointName: servicePointName
              },
          };
          let res = await matchTeamSignUpV2(params)

          if (res.code == 0) {
              wx.miniProgram.navigateTo({url: '/subpackages/home/winterGame/createTeamSuc/index'})
          } else {
              Toast(res.message);
          }
      },
  }
}
</script>

<style lang="less">
  #app {
    height: 100%;
  }
  .page-container {
    padding:32px 64px;
    width: 100%;
    height: 100%;
    flex-direction: column;
    display: flex;
    font-family: PingFangSC-Semibold, PingFang SC;
    .page-module {
      height: 85%;
      .page-title {
        font-size: 40px;
        font-weight: 600;
        color: #323232;
        line-height: 56px;
        text-align: center;
      }
      .msg{
        font-size: 28px;
        font-weight: 400;
        color: #68707D;
        line-height: 40px;
        text-align: center;
        margin: 40px 0 88px;
      }
      .main-content {
        .title {
          font-size: 28px;
          font-weight: 400;
          color: #323232;
          line-height: 40px;
          margin: 56px 0 24px;
        }
        .margin-left-16{
          margin-left: 16px;
        }
        .tips{
          font-size: 24px;
          color: #999999;
          line-height: 40px;
        }
        .team-name {
            width: 100%;
            height: 88px;
            border: 1px solid #E1E1E1;
            outline: none;
            -webkit-appearance: none; /*去除系统默认的样式*/
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
            border-radius: 16px;
            // display: block;
            text-align: center;
            font-size: 32px;
            color: #323232;
        }
        .team-name::-webkit-input-placeholder{
          color: #999999;
        }

      }
    }
    .bottom-content {
      .tips-1 {
        margin-bottom: 32px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF506F;
        text-align: center;
      }
      .sign-button {
        width: 600px;
        height: 96px;
        margin: 0 auto;
        background: #58ABF6;
        border-radius: 57px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 36px;
        &:hover {
          opacity: 0.8;
        }
        &:active {
          opacity: 0.8;
        }
      }
    }
  }
</style>
